import { Injectable } from '@angular/core';
import { arrayNotEmpty } from 'class-validator';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection } from 'src/app/core/services/functions.service';
import { QueriesService } from 'src/app/core/services/queries.service';
import { environment } from 'src/environments/environment';
import { ModuloMenuSicfModel } from '../models/modulo-menu.model';

@Injectable({
  providedIn: 'root'
})
export class ModulosService {

  private TABLA_PRINCIPAL: string = "modulos_sicf"

  constructor(
    private queriesService: QueriesService,
  ) { }

  async findAll(): Promise<BasicResponse> {
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL)
      .select("codigo_modulo as codigo", "descripcion_modulo as descripcion", "activo")
      .where({ version_jamaradmin: environment.version })
      .execute()
    return result
  }

  async findOne(codigo: string): Promise<BasicResponse> {
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL).where({ c_emp: getConnection(), codigo_modulo: codigo }).execute()
    result.data = arrayNotEmpty(result.data) ? result.data[0] : null
    return result
  }

  async create(value: ModuloMenuSicfModel): Promise<BasicResponse> {
    const id = (await this.queriesService.table(this.TABLA_PRINCIPAL)
      .select("(TO_CHAR(max(codigo_modulo))+1)as id")
      .where("REGEXP_LIKE(codigo_modulo, '^[[:digit:]]+$')")
      .execute()).data[0].id
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL).insert({
      c_emp: getConnection(),
      codigo_modulo: Number(id),
      ...value,
      version_jamaradmin: environment.version
    }).execute()
    return result
  }

  async update(value: any, where: any) {
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL).update(value, where, 1).execute()
    return result
  }
}